<template>
  <div class="flex xl:justify-center font-roboto break-words">
    <table v-if="tableData && tableData.length > 0" class="w-full border-separate border-spacing-y-1.5 px-1.5">
      <thead>
        <tr class="rounded-lg border border-white shadow-[0_0_10px_0_#00000026]">
          <th v-for="(header, index) in tableHeaders" :key="header.title" @click="sortClicked(header)"
            class="px-[8px] py-[12px] text-sm font-medium cursor-pointer" :class="{
              'rounded-l-lg': index === 0,
              'rounded-r-lg flex justify-end !pr-[20px]': index === tableHeaders.length - 1,
              '!bg-customBlue-100 text-white': true,
            }">
            <span class="flex items-center">
              <span v-if="header.sort_applicable == '1'" class="max-h-5">
                <button v-if="header.sort_direction == ''" class="p-0 border-0 focus:outline-none">
                  <!-- <img src="../../assets/images/default-sort.svg" alt="Sorting Arrow" class="w-4 h-4 object-contain"> -->
                </button>
                <button v-else-if="header.sort_direction == 'ASC'" class="p-0 border-0 focus:outline-none">
                  <img src="../../assets/images/asc.svg" alt="Sorting Ascending Arrow" class="w-4 h-4 object-contain">
                </button>
                <button v-else-if="header.sort_direction == 'DESC'" class="p-0 border-0 focus:outline-none">
                  <img src="../../assets/images/desc.svg" alt="Sorting Descending Arrow" class="w-4 h-4 object-contain">
                </button>
                <button v-else class="p-0 border-0 focus:outline-none">
                  <!-- <img src="../../assets/images/default-sort.svg" alt="Sorting Arrow" class="w-4 h-4 object-contain"> -->
                </button>
              </span>
              {{ header.title }}
            </span>
          </th>
        </tr>
      </thead>
      <tbody class="bg-white text-slate-800 table-row-group space-y-2 w-full">
        <tr v-for="(item, rowIndex) in tableData" :key="rowIndex"
          class="group mt-1 transition-all duration-300 py-2 rounded-lg  shadow-[0_0_10px_0_#0000001f]">
          <td v-for="(header, colIndex) in tableHeaders" :key="header.data_value"
            class="px-[8px] py-[9px] bg-white text-sm font-medium border-y border-white border-solid group-hover:!border-customBlue-100"
            :class="{
              'rounded-l-lg': colIndex === 0,
              'rounded-r-lg': colIndex === tableHeaders.length - 1,
              'mobile:!min-w-[70px] border-l': header.data_value === 'id',
              'mobile:!min-w-[130px] border-l': header.data_value === 'first_name',
              'mobile:!min-w-[120px]': header.data_value === 'email',
              'mobile:!min-w-[130px]': header.data_value === 'phone',
              'mobile:!min-w-[150px]': header.data_value === 'distribution_frequency_text',
              'mobile:!min-w-[110px]': header.data_value === 'affiliate_type_name',
              'mobile:!min-w-[130px]': header.data_value === 'last_login_at ',
              'mobile:!min-w-[85px] mobile:!max-w-[100px]': header.data_value === 'active',
              'mobile:!min-w-[80px] mobile:!max-w-[80px] !pl-[8px] !pr-[25px] border-r': header.data_value === 'action',
            }">
            <template v-if="header.data_value === 'first_name'">
              {{ $helper.isEmpty(item.first_name) ? '-' : item.first_name }} {{ $helper.isEmpty(item.last_name) ? '-' :
                item.last_name }}
            </template>
            <template v-else-if="header.data_value === 'active'">
              <p class="m-0 font-roboto text-sm font-normal ">
                <span v-if="item.active == '1'"
                  class="text-[14px] px-[10px] py-[3px] rounded-[3px] bg-[#65B741] text-[#fff]">Active</span>
                <span v-else
                  class="text-[14px] px-[10px] py-[3px] rounded-[3px] bg-[#EA8A8A] text-[#fff]">Inactive</span>
              </p>
            </template>
            <template v-else-if="header.data_value === 'action'">
              <actionDropdown :item="item" :rowIndex="rowIndex" :totalRows="tableData.length"
                @select="(data) => select(item, data)"></actionDropdown>
            </template>
            <template v-else-if="header.data_value === 'distribution_frequency_text'">
              <div v-html="item[header.data_value]"></div>

            </template>
            <template v-else-if="header.data_value === 'last_login_at' && item[header.data_value] != 'N/A'">
              <div>
                {{ $helper.formatDateTimestamp(item[header.data_value], 'MM/DD/YYYY - hh:mm A') }}
              </div>

            </template>

            <template v-else>
              {{ item[header.data_value] }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-else
      class="flex justify-center items-center text-[20px] laptop:text-[30px] min-h-[60vh] 2xl:min-h-[80vh] m-0 text-[#333333]">
      No Record Found</p>
  </div>
</template>

<script>
import actionDropdown from '../../components/nest_components/omegaAffiliate/actionDropdown.vue';

export default {
  props: ["tableHeaders", "tableData", "sortClicked", "isLoading"],
  components: {
    actionDropdown
  },
  methods: {
    getStatusClass(status) {
      const statusClasses = {
        'approved': '#65B741',
        'pending': '#F39C12',
        'rejected': '#D7385E',
      };
      return statusClasses[status] || 'bg-gray-500';
    },
    // getTextStatusClass(textStatus) {
    //     const textStatusClasses = {
    //         'Evaluation Completed': 'text-cyan-500',
    //         'Inspection Started': 'text-blue-500',
    //     };
    //     return textStatusClasses[textStatus];
    // }
    select(item, value) {
      this.$emit('update', item, value); // emit change if needed
    },
  }
};
</script>
